const staff_movie = () => {
    if (document.querySelector('#page-staff') === null) return;

    const modal = document.getElementById("movieModal");
    const modalVideo = document.getElementById("modalVideo");
    const closeBtn = modal.querySelector(".pg-modal__close");
    const overlay = modal.querySelector(".pg-modal__overlay");

    document.querySelectorAll(".pg-staff-detail__movie__play").forEach(btn => {
        btn.addEventListener("click", () => {
            const movieUrl = btn.getAttribute("data-movie");
            modalVideo.src = movieUrl;
            modal.classList.add("is-active");
            modalVideo.play();
        });
    });

    const closeModal = () => {
        modal.classList.remove("is-active");
        modalVideo.pause();
        modalVideo.currentTime = 0;
        setTimeout(() => {
            modalVideo.src = "";
        }, 200);
    };

    overlay?.addEventListener("click", closeModal);
    closeBtn?.addEventListener("click", closeModal);
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && modal.classList.contains("is-active")) {
            closeModal();
        }
    });

    const movie = document.querySelector('.pg-staff-detail__movie');
    const container = document.querySelector('.pg-staff-detail');
    const header = document.querySelector('.l-header');
    if (!movie || !container) return;

    const placeholder = document.createElement('div');
    placeholder.style.display = 'none';
    placeholder.style.flexShrink = '0';
    movie.parentNode.insertBefore(placeholder, movie);

    let lastState = 'relative';
    let isEnabled = window.innerWidth > 768; // PCのみ有効

    const updatePosition = () => {
        // SPなら固定機能を無効化してリセット
        if (!isEnabled) {
            placeholder.style.display = 'none';
            movie.style.display = 'block';
            movie.style.position = 'relative';
            movie.style.top = 'auto';
            movie.style.bottom = 'auto';
            movie.style.left = 'auto';
            movie.style.width = '';
            return;
        }

        const scrollY = window.scrollY || window.pageYOffset;
        const containerTop = container.offsetTop;
        const containerHeight = container.offsetHeight;
        const movieHeight = movie.offsetHeight;
        const headerHeight = header ? header.offsetHeight : 0;

        const parentRect = placeholder.getBoundingClientRect();
        const parentLeft = parentRect.left + window.scrollX;
        const parentWidth = placeholder.offsetWidth || movie.offsetWidth;

        const startFix = containerTop;
        const endFix = containerTop + containerHeight - movieHeight - headerHeight;

        if (scrollY < startFix - headerHeight) {
            if (lastState !== 'relative') {
                movie.style.position = 'relative';
                movie.style.top = 'auto';
                movie.style.bottom = 'auto';
                movie.style.left = 'auto';
                movie.style.width = '';
                placeholder.style.display = 'none';
                lastState = 'relative';
            }
        } else if (scrollY >= startFix - headerHeight && scrollY < endFix) {
            if (lastState !== 'fixed') {
                const rect = movie.getBoundingClientRect();
                const currentLeft = rect.left + window.scrollX;
                const currentWidth = rect.width;

                placeholder.style.display = 'block';
                placeholder.style.width = currentWidth + 'px';
                placeholder.style.height = movie.offsetHeight + 'px';

                requestAnimationFrame(() => {
                    movie.style.position = 'fixed';
                    movie.style.top = headerHeight + 'px';
                    movie.style.left = currentLeft + 'px';
                    movie.style.width = currentWidth + 'px';
                    movie.style.bottom = 'auto';
                    lastState = 'fixed';
                });
            }
        } else {
            if (lastState !== 'absolute') {
                const rect = placeholder.getBoundingClientRect();
                const currentLeft = rect.left + window.scrollX;
                const currentWidth = rect.width;

                placeholder.style.display = 'block';
                placeholder.style.width = currentWidth + 'px';
                placeholder.style.height = movie.offsetHeight + 'px';

                movie.style.position = 'absolute';
                movie.style.top = 'auto';
                movie.style.bottom = '0';
                movie.style.left = currentLeft + 'px';
                movie.style.width = currentWidth + 'px';
                lastState = 'absolute';
            }
        }
    };

    // 画面リサイズでSP⇄PCを検知
    const handleResize = () => {
        const nowEnabled = window.innerWidth > 768;
        if (isEnabled !== nowEnabled) {
            isEnabled = nowEnabled;
            lastState = ''; // 状態リセットして再描画
            updatePosition();
        }
    };

    window.addEventListener('scroll', updatePosition);
    window.addEventListener('resize', () => {
        handleResize();
        updatePosition();
    });

    updatePosition();
};
export default staff_movie;
